import Vue from 'vue'
import Router from 'vue-router'
import native from '@zz-common/native-adapter/es/all'
import { needLogin } from '@src/lib/login'
import { initLegoData, legic } from '@src/lib/legic'
import routesConfig from './route'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/u/hunter-market',
  routes: routesConfig
})

router.beforeEach((to, from, next) => {
  // 初始化 pageType、channel
  initLegoData({ routerPath: to.path })
  const matched = to.matched.length > 0
  if (!matched) {
    next({
      path: '/404',
      query: {
        lastPath: to.path,
        timestamp: Date.now()
      }
    })
  }
  // 如果设置标题，拦截后设置标题
  if (to.meta.title) {
    native.setTitle({ title: to.meta.title })
  }
  if (to.matched.some((record) => record.meta.auth)) {
    needLogin().then((res) => {
      if (res) {
        legic('', 'pageShow')
        next()
      } else {
        // 用户拒绝在需要登录的页面上登录，则退出当前页面
        native.wrap('close')()
      }
    })
  } else {
    legic('', 'pageShow')
    next()
  }
})

export default router
